<template>
  <main class="main">
    <!-- Pricing/Services Section -->
    <SectionTitle 
      title="Our Services"
      subtitle="Professional Electrolysis Solutions"
      id="services-title"
    />

    <!-- Information Section with icon -->
    <section id="about-services" class="about mb-4 bg-secondary bg-opacity-10">
      <div class="container py-4">
        <div class="row g-3 align-items-stretch">
          <div class="col-lg-6">
            <div class="card h-100 border-0">
              <div class="card-body p-4">
                <h4 class="mb-4">
                  <i class="bi bi-exclamation-circle me-2 text-success"></i>
                  All first-time clients must schedule a consultation before booking their first treatment session.
                </h4>
                <div class="mb-0">
                  <p class="mb-0">Our complimentary consultation is designed to ensure you have all the information needed to feel confident about your treatment journey. While the consultation is free, please note that any treatment services are not included.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card h-100 border-0">
              <div class="card-body p-4">
                <h5 class="mb-3">During your consultation, you can expect to:</h5>
                <ul class="list-unstyled">
                  <li class="mb-2"><i class="bi bi-check2-circle me-2"></i> Discuss the treatment process in detail</li>
                  <li class="mb-2"><i class="bi bi-check2-circle me-2"></i> Review your health history</li>
                  <li class="mb-2"><i class="bi bi-check2-circle me-2"></i> Identify areas for treatment</li>
                  <li class="mb-2"><i class="bi bi-check2-circle me-2"></i> Address any concerns you may have</li>
                  <li><i class="bi bi-check2-circle me-2"></i> Complete necessary waiver forms</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="pricing" class="pricing section pb-4">
      <div class="container">
        <div class="row gy-4">
          <div class="col-lg-4 col-md-6" v-for="service in servicesData.services" :key="service.name" data-aos="zoom-in" :data-aos-delay="service.delay">
            <div class="pricing-tem" :class="service.bgClass">
              <span v-if="service.featured" class="featured">Free</span>
              <h3 :style="{ color: service.color }">{{ service.name }}</h3>
              <div class="fw-bold text-uppercase mt-2 mb-3" :style="{ color: service.color }">
                {{ service.period }}
              </div>
              <div class="price">
                <template v-if="service.price !== 'Free'">
                  <sup>$</sup>{{ service.price }}
                </template>
                <template v-else>
                  {{ service.price }}
                </template>
              </div>
              <div v-if="service.icon" class="icon">
                <i :class="'bi ' + service.icon" :style="{ color: service.color }"></i>
              </div>
              <ul v-if="service.features && service.features.length">
                <li v-for="(feature, index) in service.features" 
                    :key="index"
                    :class="{ 'na': !feature.included }">
                  {{ feature.text }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import servicesData from '@/data/services.json'
import SectionTitle from '@/components/common/SectionTitle.vue'

export default {
  name: "ServicesView",
  components: {
    SectionTitle
  },
  setup() {
    return {
      servicesData
    }
  }
}
</script>